export default function validatePassCode(code) {
  let regex = /^\d{4}$/g;

  return regex.test(code);
}
